<template>
    <div class="top-sidebar">
<!--        {{ cart }}-->
        <div class="d-flex justify-content-between">
            <div class="top__item" v-for="(m, mind) in menu">
                <div class="top__item" :class="{ active: step === (mind + 1) }"  @click="stepClicked((mind + 1))">
                    <div class="top__title d-md-block d-none">{{ (mind+1) }}. {{ m.title }}</div>
                    <div class="top__title d-md-none d-block">{{ m.mob_title }}</div>
                    <div class="top__subtitle d-md-block d-none">{{ m.note }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'

    export default {
        computed: {
            ...mapState(['step','cart','order'])
        },
        data() {
            return {
                menu: [
                    { title: 'Расписание', mob_title: "Расписание", note: 'Выберите дату мероприятия' },
                    { title: 'Схема зала', mob_title: "Зал", note: 'Выберите сектор' },
                    { title: 'Схема сектора', mob_title: "Сектор", note: 'Выберите места' },
                    { title: 'Оформление', mob_title: "Оформление", note: 'Заполните данные' },
                ]
            }
        },
        methods: {
            stepClicked(step) {
                if(this.step == 4) {
                    return
                }
                if(step == 1) {
                    this.$router.push('/')
                }
                if(step == 2 && this.step == 3) {
                    this.$store.commit('setStep', 2)
                }
                if(step == 4 && this.cart.length > 0) {
                    this.$store.dispatch('generateOrder').then(res => {
                        this.$router.push('/order/'+res.id+'/'+res.hash)
                    })
                }
            }
        }
    }
</script>

<style scoped>

</style>